import { render, staticRenderFns } from "./FormRecordSituations.vue?vue&type=template&id=080c2904"
import script from "./FormRecordSituations.vue?vue&type=script&lang=js"
export * from "./FormRecordSituations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports